import { IAuthStrategy } from "./interfaces/IAuthStrategy";
import { IAuthManager } from "./interfaces/IAuthManager";

/**
 * Responsible for managing the authentication strategy
 * and performing authentication-related operations.
 */
export class AuthManager implements IAuthManager {
  client: IAuthStrategy | undefined;

  private checkClient() {
    if (!this.client) {
      throw new Error("Client is not set");
    }
  }

  /**
   * Sets the authentication strategy client and configures it.
   * @param newClient - The new authentication strategy client.
   */
  public setClient(newClient: IAuthStrategy) {
    this.client = newClient;
  }

  /**
   * Performs a login operation using the authentication strategy client.
   */
  public login(
    email: string,
    password: string,
    {
      otp_token,
      captcha_token,
    }: {
      otp_token?: string;
      captcha_token: string | undefined;
    }
  ) {
    this.checkClient();
    return this.client?.login(email, password, {
      otp_token,
      captcha_token,
    });
  }

  public loginWithGoogle(code: string) {
    this.checkClient();
    return this.client?.loginWithGoogle(code);
  }

  public loginWithFacebook(access_token: string) {
    this.checkClient();
    return this.client?.loginWithFacebook(access_token);
  }

  /**
   * Performs a logout operation using the authentication strategy client.
   */
  public logout() {
    this.checkClient();
    return this.client?.logout();
  }

  /**
   * Checks if the user is authenticated using the authentication strategy client.
   */
  public checkAuth() {
    this.checkClient();
    if (!this.client?.checkAuth) {
      throw new Error("Not implemented");
    }
    return this.client.checkAuth();
  }
}
